/* Veilleuse Ma Petite Tribu Dino — configurateur (copie de Ma Petite Tribu avec les 12 dinos). Monté sur chaque [data-td] de la page.
   Repère = photo 805 x 805. Chaque animal : hauteur = taille(nombre) x échelle(animal), une part cachée derrière le socle. */
(function(){
  function init(root){
  if(root.dataset.tdPret) return; root.dataset.tdPret='1';
  var BASE=root.dataset.base, VERSION_IMAGES='5';
  var P={cx:403.5,bas:553};
  // réglages validés (écart entre les centres, taille de référence = hauteur de la girafe, hauteur)
  var REG={1:{ecart:0,taille:449.35,haut:2},2:{ecart:191,taille:350,haut:0},3:{ecart:157,taille:282,haut:0}};
  // r = largeur/hauteur de l'image, e = échelle par rapport à la girafe, c = part cachée derrière le socle
  var ANIMAUX=[{id:'trex',n:'T-rex',r:0.705,e:0.76,c:0.2},
    {id:'triceratops',n:'Tricératops',r:0.7987,e:0.76,c:0.2},
    {id:'diplodocus',n:'Diplodocus',r:0.7281,e:0.9,c:0.2},
    {id:'stegosaure',n:'Stégosaure',r:0.8419,e:0.76,c:0.2},
    {id:'pterodactyle',n:'Ptérodactyle',r:0.7147,e:0.78,c:0.18},
    {id:'ankylosaure',n:'Ankylosaure',r:0.9519,e:0.74,c:0.2},
    {id:'parasaurolophus',n:'Parasaurolophus',r:0.8339,e:0.8,c:0.2},
    {id:'spinosaure',n:'Spinosaure',r:0.9016,e:0.74,c:0.2},
    {id:'brachiosaure',n:'Brachiosaure',r:0.5828,e:1.0,c:0.2},
    {id:'raptor',n:'Vélociraptor',r:0.7069,e:0.8,c:0.2},
    {id:'oeuf',n:"Bébé dans l'œuf",r:0.5748,e:0.78,c:0.16},
    {id:'plesiosaure',n:'Plésiosaure',r:0.8941,e:0.8,c:0.2}];
  var NOM={y:{1:220,2:246,3:270},size:82,max:430,couleur:'#FFF4D6',vide:'rgba(255,244,214,.55)'};
  var ETOILES=[[-176.9,133.8,5.4],[63.9,56.3,4.2],[173.7,177,2.8],[5,246.5,3.2],[-175.4,249,4.8],[-115.9,53.8,5.4],[-15,30.5,4.2],[-95.3,234.4,5.4],[232.4,221.5,4.2],[113.4,244.6,2.8],[-221.7,186,2.8],[164,89,2.8],[-252.4,247.3,3.6]];
  var DEFAUT=['trex','triceratops','diplodocus'];
  var etat={nombre:3,animaux:DEFAUT.slice(),place:0,prenom:''};
  var APERCU=root.querySelector('.vn__apercu'), SVGNS='http://www.w3.org/2000/svg';
  function $(s){return root.querySelector(s)||APERCU.querySelector(s)}
  function img(id){return BASE+(id==='photo'?'tr-':'td-')+id+'.webp?v='+VERSION_IMAGES}   // photo de l'arche commune avec Ma Petite Tribu
  function animal(id){return ANIMAUX.filter(function(a){return a.id===id})[0]}

  $('[data-tr-photo]').setAttribute('href',img('photo'));
  $('[data-tr-etoiles]').innerHTML=ETOILES.map(function(e){return '<circle cx="'+(P.cx+e[0])+'" cy="'+(80+e[1])+'" r="'+e[2]+'"/>'}).join('');
  $('[data-tr-nombre]').innerHTML=[1,2,3].map(function(k){return '<button type="button" role="radio" data-nombre="'+k+'">'+k+'</button>'}).join('');
  $('[data-tr-zoo]').innerHTML=ANIMAUX.map(function(a){return '<button type="button" role="radio" data-animal="'+a.id+'" aria-label="'+a.n+'"><img src="'+img(a.id+'-tete')+'" alt="" width="70" height="70" loading="lazy"><span>'+a.n+'</span></button>'}).join('');
  setTimeout(function(){ANIMAUX.forEach(function(a){new Image().src=img(a.id)})},1500);

  function ajusterNom(){
    var t=$('[data-tr-nom]'); t.setAttribute('font-size',NOM.size);
    try{var w=t.getComputedTextLength(); if(w>NOM.max) t.setAttribute('font-size',(NOM.size*NOM.max/w).toFixed(1))}catch(e){}
  }
  function dessinerAnimaux(){
    var g=REG[etat.nombre], n=etat.nombre, grp=$('[data-tr-animaux]'); grp.innerHTML='';
    etat.animaux.slice(0,n).forEach(function(id,j){
      var a=animal(id), h=g.taille*a.e, w=h*a.r, x=P.cx+(j-(n-1)/2)*g.ecart-w/2, y=P.bas+h*a.c-h-g.haut;
      var im=document.createElementNS(SVGNS,'image'); im.setAttribute('href',img(id));
      im.setAttribute('x',x.toFixed(1)); im.setAttribute('y',y.toFixed(1)); im.setAttribute('width',w.toFixed(1)); im.setAttribute('height',h.toFixed(1));
      grp.appendChild(im);
    });
  }
  function rendu(){
    var n=etat.nombre; if(etat.place>=n) etat.place=n-1;
    root.querySelectorAll('[data-nombre]').forEach(function(b){b.setAttribute('aria-checked',+b.dataset.nombre===n)});
    $('[data-tr-places]').innerHTML=etat.animaux.slice(0,n).map(function(id,j){var a=animal(id);
      return '<button type="button" role="tab" data-place="'+j+'" aria-selected="'+(j===etat.place)+'"><img src="'+img(id+'-tete')+'" alt="" width="40" height="40"><span>Dino '+(j+1)+'<b>'+a.n+'</b></span></button>'}).join('');
    var actuel=etat.animaux[etat.place];
    root.querySelectorAll('[data-animal]').forEach(function(b){b.setAttribute('aria-checked',b.dataset.animal===actuel)});
    dessinerAnimaux();
    var reste=13-Array.from(etat.prenom).length; $('[data-tr-compteur]').textContent=reste+(reste>1?' restants':' restant');
    var t=$('[data-tr-nom]'); t.setAttribute('y',NOM.y[n]); t.textContent=etat.prenom||'Prénom'; t.setAttribute('fill',etat.prenom?NOM.couleur:NOM.vide); ajusterNom();
    $('[data-tr-p-nombre]').value=String(n);
    [1,2,3].forEach(function(k){var f=$('[data-tr-p-a'+k+']'); f.disabled=k>n; f.value=k<=n?animal(etat.animaux[k-1]).n:''});
    $('[data-tr-p-prenom]').value=etat.prenom;
  }
  root.addEventListener('click',function(e){
    var b=e.target.closest('button'); if(!b||!root.contains(b)) return;
    if(b.dataset.nombre){etat.nombre=+b.dataset.nombre}
    else if(b.dataset.place){etat.place=+b.dataset.place}
    else if(b.dataset.animal){etat.animaux[etat.place]=b.dataset.animal; if(etat.place<etat.nombre-1) etat.place++}
    else return;
    rendu(); montrerApercu();
  });
  $('[data-tr-prenom]').addEventListener('input',function(e){
    var v=e.target.value.replace(/[^A-Za-zÀ-ÖØ-öø-ÿŒœ' \-]/g,'').replace(/\s{2,}/g,' ');
    v=Array.from(v).slice(0,13).join(''); if(v!==e.target.value) e.target.value=v;
    etat.prenom=v.trim(); $('[data-tr-erreur]').hidden=true; rendu(); montrerApercu();
  });

  // option ajoutée au panier avec la veilleuse : adaptateur secteur USB
  var OPTION={handle:'adaptateur-usb-prise-secteur-220v',variante:47304866333003,prixNum:4.49};
  var caseOpt=$('[data-tr-option]'), blocOption=caseOpt.closest('.vn__carte'), prixOption=blocOption.querySelector('em');
  var prixBase=null;
  function lirePrix(t){var m=String(t||'').replace(/\s/g,'').match(/(\d+)[.,](\d{2})/);return m?parseFloat(m[1]+'.'+m[2]):null}
  function majPrixBouton(){
    var cibles=document.querySelectorAll('.kp-btn-prix'); if(!cibles.length) return;
    if(prixBase===null) prixBase=lirePrix(cibles[0].textContent); if(prixBase===null) return;
    var txt=(prixBase+(caseOpt.checked?OPTION.prixNum:0)).toFixed(2).replace('.',',')+' €';
    [].forEach.call(cibles,function(c){if(c.textContent!==txt) c.textContent=txt});
  }
  caseOpt.addEventListener('change',majPrixBouton);
  new MutationObserver(function(){majPrixBouton()}).observe(document.body,{childList:true,subtree:true,characterData:true});
  var vignette=document.createElement('img'); vignette.alt=''; vignette.width=48; vignette.height=48;
  vignette.setAttribute('style','width:48px;height:48px;object-fit:contain;border-radius:6px;background:#fff;flex:none;display:none');
  blocOption.insertBefore(vignette,blocOption.children[1]);
  fetch('/products/'+OPTION.handle+'.js').then(function(r){return r.json()}).then(function(p){
    var v=(p.variants||[]).filter(function(x){return x.id===OPTION.variante})[0]||p.variants[0];
    if(v){OPTION.variante=v.id; OPTION.prixNum=v.price/100; prixOption.textContent='+'+(v.price/100).toFixed(2).replace('.',',')+' €'; if(!v.available){blocOption.style.display='none';caseOpt.checked=false} majPrixBouton()}
    if(p.featured_image){vignette.src=p.featured_image.replace(/(\.[a-z]+)(\?|$)/i,'_96x96$1$2'); vignette.style.display=''}
  }).catch(function(){});

  // s'installe dans le formulaire produit, juste avant le bouton d'ajout au panier
  var form=document.querySelector('form[data-product-form]')||document.querySelector('form[action*="/cart/add"]');
  if(form){
    var cible=form.querySelector('.product-single__add-to-cart');
    if(cible) cible.parentNode.insertBefore(root,cible); else form.appendChild(root);
  }

  // l'aperçu prend la place de la première photo du carrousel
  var apercu=APERCU, svg=apercu.querySelector('svg'), galerie=null;
  var media=document.querySelector('.product-single__media-group .product-single__media-wrapper .product--wrapper')||document.querySelector('.product-single__media-group .product-single__media');
  if(media){
    if(getComputedStyle(media).position==='static') media.style.position='relative';
    media.appendChild(apercu); apercu.classList.add('vn__apercu--galerie');
    galerie=media.closest('.product-single__media-wrapper')||media;
    var note=root.querySelector('.vn__note'); if(note) note.hidden=true;
  }
  function montrerApercu(){
    if(!galerie) return;
    var slider=galerie.closest('.slick-slider'), jq=window.jQuery;
    if(slider&&jq&&jq.fn&&jq.fn.slick){
      var $s=jq(slider), idx=jq(galerie).closest('.slick-slide').data('slick-index')||0;
      if($s.slick('slickCurrentSlide')!==idx) $s.slick('slickGoTo',idx);
      return;
    }
    if(galerie.offsetParent!==null) return;
    var id=(galerie.id||'').split('-').pop();
    var v=id&&document.querySelector('[data-thumbnail-id$="'+id+'"],[data-media-id$="'+id+'"],[href*="'+id+'"]');
    if(v) v.click();
  }

  // mobile : aperçu fixé en haut de l'écran pendant le choix des options
  var sceneId='trScene-'+Math.random().toString(36).slice(2,8), scene=document.createElementNS(SVGNS,'g');
  scene.setAttribute('id',sceneId);
  Array.prototype.slice.call(svg.childNodes).forEach(function(n){if(n.nodeName!=='defs') scene.appendChild(n)});
  svg.appendChild(scene);
  var flot=document.createElement('div'); flot.className='vn-flottant'; flot.setAttribute('aria-hidden','true');
  flot.innerHTML='<div class="vn-flottant__vue"><svg viewBox="0 0 805 805"><use href="#'+sceneId+'"/></svg></div>';
  document.body.appendChild(flot);
  var ZOOMS=[1,1.4,1.8], niveauZoom=0, vue=flot.querySelector('svg'), groupeZoom=document.createElement('div');
  var LOUPE='<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21"/>';
  groupeZoom.className='vn-zoom';
  groupeZoom.innerHTML='<button type="button" data-zoom="1" aria-label="Zoomer sur l\'aperçu">'+LOUPE+'<path d="M10.5 7.5v6M7.5 10.5h6"/></svg></button>'
    +'<button type="button" data-zoom="-1" aria-label="Dézoomer l\'aperçu">'+LOUPE+'<path d="M7.5 10.5h6"/></svg></button>';
  groupeZoom.addEventListener('click',function(e){var b=e.target.closest('[data-zoom]');if(!b)return;e.preventDefault();e.stopPropagation();
    niveauZoom=Math.max(0,Math.min(ZOOMS.length-1,niveauZoom+(+b.dataset.zoom)));appliquerZoom()});
  flot.appendChild(groupeZoom);
  function appliquerZoom(){
    var z=ZOOMS[niveauZoom]; vue.style.transformOrigin='50% 50%'; vue.style.transform=z===1?'':'scale('+z+')';
    groupeZoom.querySelector('[data-zoom="1"]').disabled=niveauZoom===ZOOMS.length-1; groupeZoom.querySelector('[data-zoom="-1"]').disabled=niveauZoom===0;
  }
  appliquerZoom();
  var zonePanier=form&&form.querySelector('.product-single__add-to-cart');
  function majFlottant(){
    if(window.innerWidth>768){flot.classList.remove('is-visible');return}
    var h=flot.offsetHeight||300, a=apercu.getBoundingClientRect(), p=(zonePanier||root).getBoundingClientRect();
    flot.classList.toggle('is-visible', a.bottom<=h && p.bottom>h);
  }
  window.addEventListener('scroll',majFlottant,{passive:true}); window.addEventListener('resize',majFlottant);

  // contrôle avant l'ajout au panier (bouton principal et barre collante)
  var optionAjoutee=false;
  function boutonAjout(t){return t.closest&&t.closest('button[name="add"], .btn--add-to-cart, [data-sticky-addtocart], .dbtfy-sticky-addtocart button')}
  document.addEventListener('click',function(e){
    var b=boutonAjout(e.target); if(!b) return;
    if(!etat.prenom){
      e.preventDefault(); e.stopImmediatePropagation();
      $('[data-tr-erreur]').hidden=false; $('[data-tr-prenom]').focus();
      root.scrollIntoView({behavior:'smooth',block:'center'}); return;
    }
    if(caseOpt.checked&&!optionAjoutee){
      e.preventDefault(); e.stopImmediatePropagation();
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[{id:Number(OPTION.variante),quantity:1}]})})
        .then(function(){optionAjoutee=true;b.click()})
        .catch(function(){optionAjoutee=true;b.click()});
    }
  },true);
  if(form) form.addEventListener('submit',function(e){
    if(!etat.prenom){e.preventDefault();e.stopImmediatePropagation();$('[data-tr-erreur]').hidden=false;$('[data-tr-prenom]').focus()}
  },true);

  // ordinateur : bouton « Voir l'aperçu » qui ouvre l'aperçu en grand
  var champPrenom=root.querySelector('.vn__prenom'), voir=document.createElement('button');
  voir.type='button'; voir.className='vn__voir'; voir.textContent='Voir l\'aperçu de ma veilleuse';
  champPrenom.parentNode.insertBefore(voir,champPrenom.nextSibling);
  var fen=document.createElement('div'); fen.className='vn-fenetre'; fen.hidden=true;
  fen.setAttribute('role','dialog'); fen.setAttribute('aria-modal','true'); fen.setAttribute('aria-label','Aperçu de votre veilleuse');
  fen.innerHTML='<div class="vn-fenetre__boite"><button type="button" class="vn-fenetre__fermer" aria-label="Fermer">&times;</button>'
    +'<svg viewBox="0 0 805 805"><use href="#'+sceneId+'"/></svg><p class="vn-fenetre__texte"></p></div>';
  document.body.appendChild(fen);
  function ouvrirFen(){
    fen.querySelector('.vn-fenetre__texte').textContent=etat.animaux.slice(0,etat.nombre).map(function(id){return animal(id).n}).join(' · ')+(etat.prenom?' · '+etat.prenom:'');
    fen.hidden=false; fen.querySelector('.vn-fenetre__fermer').focus();
  }
  function fermerFen(){fen.hidden=true; voir.focus()}
  voir.addEventListener('click',ouvrirFen);
  fen.addEventListener('click',function(e){if(e.target===fen||e.target.closest('.vn-fenetre__fermer')) fermerFen()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!fen.hidden) fermerFen()});

  // vignettes du panier (script commun aux veilleuses)
  if(!window.vnPanier){var sp=document.createElement('script'); sp.src=BASE+'vn-veilleuse-panier.js?v=h'+Math.floor(Date.now()/36e5); sp.defer=true; document.head.appendChild(sp)}

  rendu(); majFlottant(); majPrixBouton();
  if(document.fonts&&document.fonts.load) document.fonts.load('700 82px "Dancing Script"').then(ajusterNom,ajusterNom);
  }
  function go(){document.querySelectorAll('[data-td]').forEach(init)}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go); else go();
})();
